import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TranslatorService} from '../../../../translation/translator.service';
import {Notification} from '../../../state/notification';
import {AccountDataQuery} from '../../../../account/account-data-query';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AccountDataFunctions} from '../../../../account/account-data';

@Component({
  selector: 'app-test-expiring-master-message',
  templateUrl: './test-expiring-master-message.component.html',
  styleUrls: ['./test-expiring-master-message.component.scss']
})
export class TestExpiringMasterMessageComponent implements OnInit, OnDestroy {

  @Input()
    notification: Notification;

  private unsubscribe$: Subject<void> = new Subject<void>();

  userId: string = '...';
  userName: string = '...';
  messagePartA: string = '';
  messagePartB: string = '';

  constructor(private accountDataQuery: AccountDataQuery,
              private translatorService: TranslatorService) {
  }

  ngOnInit(): void {
    this.computeMessage();
    this.accountDataQuery.selectAccountData(this.notification.data.userId as string)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(accountData => this.userName = AccountDataFunctions.fullName(accountData));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  computeMessage(): void {
    this.messagePartA = this.__('partA');
    this.messagePartB = this.__('partB');
  }

  __(key: string): string {
    return this.translatorService.translate('notification.' + this.notification.type + '.message.' + key);
  }

}
